import React from "react";
import styles from "../PreviewV3.module.css";

export default function EmergencyContacts({ sectionData, displayName, sectionNumber, targetId}) {

  const emergencyTypes = sectionData.types || [];

  return (
    <div className={styles.PreviewSectionBlock} id={targetId} style={{ scrollMarginTop: "140px" }}>
      <div className={styles.PreviewSectionHead}>
        <span className={styles.PreviewSectionNum}>{sectionNumber}</span>
        {displayName}
      </div>
      <div className={styles.PreviewSectionBody}>
        <table className={`${styles.PreviewTable} ${styles.EmergncyTable}`}>
          <thead>
            <tr>
              <th>Contact / Service Name</th>
              <th width="35%">Phone Number</th>
            </tr>
          </thead>
          <tbody>
            {emergencyTypes.map((emergencyType, index) => (
              <EmergencyTypeRow key={index} emergencyType={emergencyType} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const EmergencyTypeRow = ({ emergencyType }) => {
  const contacts = emergencyType.contacts || [];

  return (
    <>
      <tr className={styles.EmergencyTypeRow}>
        <td colSpan={2}>
          <strong>{emergencyType && emergencyType.emergency_type}</strong>
        </td>
      </tr>
      {contacts.map((contact, index) => {
        const item = contact || {};
        return (
          <tr key={index}>
            <td>{item.contact_name}</td>
            <td>{item.phone_number}</td>
          </tr>
        );
      })}
    </>
  );
}